export const SKY_ENERGY = 'ZO6X8hQAACUAghHg';
export const EMPLOYMENT_ONE = 'Zai0bRAAAB8AtT9Z';
